import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: BASE });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("speca_admin_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const authLogin = async (email, password) => {
  const { data } = await api.post("/admin/login", { email, password });
  localStorage.setItem("speca_admin_token", data.access_token);
  return data.user;
};

export const authMe = async () => {
  const { data } = await api.get("/admin/me");
  return data;
};

export const authLogout = () => localStorage.removeItem("speca_admin_token");

export const submitEnquiry = async (payload) => {
  const { data } = await api.post("/enquiries", payload);
  return data;
};

export const listEnquiries = async () => {
  const { data } = await api.get("/enquiries");
  return data;
};

export const updateEnquiryStatus = async (id, status) => {
  const { data } = await api.patch(`/enquiries/${id}`, { status });
  return data;
};
